import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { BiodirectQuery, BiodirectQueryVariables } from '@/shared/api';
import BIODIRECT_STUDY_QUERY from '../queries/biodirect';

/**
 * Loads the Bioflux Direct study identified by the given id. Runs BIODIRECT_STUDY_QUERY and throws the first GraphQL error message when the study field is nil.
 *
 * @param id - Identifier of the Bioflux Direct study.
 * @returns The study record.
 */
const fetchBiodirect = async (id: any) => {
  const client = createClient();
  const biodirectResult = await client.query<BiodirectQuery, BiodirectQueryVariables>({
    query: BIODIRECT_STUDY_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = biodirectResult;
  const { study } = data;
  if (_.isNil(study) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return study;
};

export default fetchBiodirect;
